import axiosInstance from '../../../config/axiosInstance';
import { InvoiceValidation } from "../View/Validation/InvoiceValidation";

const handleChange = (event, formData, setFormData) => {
  const { name, value } = event.target;
  setFormData({
    ...formData,
    [name]: value,
  });
};

const handleSubmit = async (event, formData, setFormData, setErrors,redirectCallback,redirectRoleList) => {
 
  event.preventDefault();
  const formErrors = InvoiceValidation(formData);
  setErrors(formErrors);
  if (Object.keys(formErrors).length === 0) {
    try {
      const CompanyID=localStorage.getItem("CompanyID");
      formData.formData.ClientID=CompanyID;
      const UserID=localStorage.getItem("UserID");
      formData.formData.UserID=UserID;
      const response = await axiosInstance.post(`/Invoice/CreateInvoice`, formData);
      localStorage.setItem('InvoiceID', response.data.InvoiceID);
      return response.data.message;
     
    } catch (error) {
      console.error('Error posting data:', error);
    }
  }
};

export { handleChange, handleSubmit };